module.exports = __webpack_public_path__ + "img/facebook_icon.3d63d7ea.svg";